import { useState, useEffect } from 'react';

// material-ui
import {
    Button,
    FormHelperText,
    Grid,
    TextField
} from '@mui/material';

// project imports
import { gridSpacing } from 'store/constant';
import useApi from 'hooks/useApi';
import VenueService from 'services/VenueService';
import validationSchema from 'utils/schema/BankAccountSchema';

// third party
import { useFormik } from 'formik';

export default function AccountDetails({ venueUuid }) {

    const [bankUuid, setBankUuid] = useState('');

    const updateBankInfo = () => {
        const formikValues = { ...formik.values };
        formikValues.uuid_venue = venueUuid;
        if (bankUuid) {
            updateBankApi.execute(formikValues, bankUuid);
        } else {
            createBankApi.execute(formikValues);
        }
    };

    const setFormValue = (data = {}) => {
        formik.setFieldValue('account_holder_name', data.account_holder_name ? data.account_holder_name : '');
        formik.setFieldValue('bank_account_number', data.bank_account_number ? data.bank_account_number : '');
        formik.setFieldValue('bank_name', data.bank_name ? data.bank_name : '');
        formik.setFieldValue('ifsc_code', data.ifsc_code ? data.ifsc_code : '');
    };

    const getBankHandler = (response) => {
        if (response.data.length) {
            setBankUuid(response.data[0].uuid);
            setFormValue(response.data[0]);
        }
    };

    const updateSuccessHandler = (response) => {
        if (response.data && response.data.bankUuid) {
            setBankUuid(response.data.bankUuid);
        }
    };

    const getBankApi = useApi(VenueService.getBankAccountList, getBankHandler);
    const createBankApi = useApi(VenueService.createBankAccount, updateSuccessHandler, true);
    const updateBankApi = useApi(VenueService.updateBankAccountByUuid, updateSuccessHandler, true);

    const formik = useFormik({
        initialValues: {
            account_holder_name: '',
            bank_account_number: '',
            bank_name: '',
            ifsc_code: ''
        },
        validationSchema: validationSchema,
        onSubmit: updateBankInfo
    });

    useEffect(() => {
        getBankApi.execute({
            venueUuid
        });
    }, []);

    return (
        <>
            <Grid container spacing={gridSpacing} mb={3}>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        type="text"
                        size="medium"
                        label="Account Holder Name*"
                        name="account_holder_name"
                        error={Boolean(formik.touched.account_holder_name && formik.errors.account_holder_name)}
                        value={formik.values.account_holder_name}
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                    />
                    {formik.touched.account_holder_name && formik.errors.account_holder_name && (
                        <FormHelperText error id="standard-weight-helper-text-account_holder_name-venue">
                            {formik.errors.account_holder_name}
                        </FormHelperText>
                    )}
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        type="text"
                        size="medium"
                        label="Bank Account Number*"
                        name="bank_account_number"
                        value={formik.values.bank_account_number}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={Boolean(formik.touched.bank_account_number && formik.errors.bank_account_number)}
                    />
                    {formik.touched.bank_account_number && formik.errors.bank_account_number && (
                        <FormHelperText error id="standard-weight-helper-text-bank_account_number-venue">
                            {formik.errors.bank_account_number}
                        </FormHelperText>
                    )}
                </Grid>
            </Grid>
            <Grid container spacing={gridSpacing} mb={3}>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        type="text"
                        size="medium"
                        label="Bank Name*"
                        name="bank_name"
                        error={Boolean(formik.touched.bank_name && formik.errors.bank_name)}
                        value={formik.values.bank_name}
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                    />
                    {formik.touched.bank_name && formik.errors.bank_name && (
                        <FormHelperText error id="standard-weight-helper-text-bank_name-venue">
                            {formik.errors.bank_name}
                        </FormHelperText>
                    )}
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        type="text"
                        size="medium"
                        label="IFSC Code*"
                        name="ifsc_code"
                        error={Boolean(formik.touched.ifsc_code && formik.errors.ifsc_code)}
                        value={formik.values.ifsc_code}
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                    />
                    {formik.touched.ifsc_code && formik.errors.ifsc_code && (
                        <FormHelperText error id="standard-weight-helper-text-ifsc_code-venue">
                            {formik.errors.ifsc_code}
                        </FormHelperText>
                    )}
                </Grid>
            </Grid>
            <Grid container justifyContent="flex-end" mt={2}>
                <Grid item>
                    <Button
                        color="secondary"
                        variant="contained"
                        onClick={formik.handleSubmit}
                    >
                        {bankUuid != 'create' ? 'Update' : 'Create'}
                    </Button>
                </Grid>
            </Grid>
        </>
    );
};